import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';

const VERSIONS = [
  'high_264',
  'twelve80_720',
  'four80_360',
  'ogg',
  'webm',
];

const Video = ({ inline, ...props }) =>
  inline ? <InlineVideo {...props} /> : <PopupVideo {...props} />;

Video.propTypes = {
  inline: PropTypes.bool,
  four80_360: PropTypes.object,
  high_264: PropTypes.object,
  ogg: PropTypes.object,
  twelve80_720: PropTypes.object,
  webm: PropTypes.object,
};

//

export const InlineVideo = props => <Player {...props} />;

export const PopupVideo = props => (
  <div>
    <VideoPopupButton
      onClick={e => {
        e.preventDefault();
        import('../../vendor/jquery.magnific-popup').then(() => {
          $.magnificPopup.open({
            items: {
              src: `#video-${props.id}`,
              type: 'inline',
            },
            mainClass: 'animated fadeIn pop-vid-container',
          });
        });
      }}
    />
    <Player {...props} className="mfp-hide" />
  </div>
);

PopupVideo.propTypes = {
  id: PropTypes.string.isRequired,
};

//

export const Player = ({ className, id, width, ...props }) => (
  <video
    id={`video-${id}`}
    className={classnames(
      className,
      'video-js vjs-default-skin attachment attachment--video'
    )}
    controls="controls"
    controlsList="nodownload"
    preload="none"
    width={width}
    poster=""
  >
    {VERSIONS.map(version =>
      props[version] ? (
        <source
          key={props[version].url}
          src={props[version].url}
          type={props[version].mime_type}
        />
      ) : null
    )}
  </video>
);

Player.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string.isRequired,
  height: PropTypes.string,
  width: PropTypes.string,
};

export const VideoPopupButton = ({ onClick }) => (
  <button
    className="vjs-popup"
    onClick={onClick}
    style={{
      border: '0',
    }}
    type="button"
  >
    <span>play video</span>
  </button>
);

VideoPopupButton.displayName = 'VideoPopupButton';

VideoPopupButton.propTypes = {
  onClick: PropTypes.func,
};

VideoPopupButton.defaultProps = {
  onClick: e => e.preventDefault(),
};

export default Video;
